import { BaseIcon } from './BaseIcon';

const CopyIcon = (props) => {
  return (
    <BaseIcon {...props}>
      <path
        d="M3 16.4067V4.40674C3 3.30217 3.89543 2.40674 5 2.40674H15M9 22.4067H18C19.1046 22.4067 20 21.5113 20 20.4067V8.40674C20 7.30217 19.1046 6.40674 18 6.40674H9C7.89543 6.40674 7 7.30217 7 8.40674V20.4067C7 21.5113 7.89543 22.4067 9 22.4067Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default CopyIcon;
